import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import { buildQueryParams } from 'utils/helpers/queryParams'

type OriginDestinationSkuType = {
  product_id: number
  product_name: string
  product_sku: string
  product_uom: string
  quantity: number
}

export type GetConversionListResponseType = {
  id: number
  rule_name: string
  type: string
  product_origins: OriginDestinationSkuType[]
  product_destinations: OriginDestinationSkuType[]
}

export type GetConversionListRequestType = {
  origin_product_ids?: number[]
  destination_product_ids?: number[]
  type?: string
  sku_origin?: string
  sku_destination?: string
  page_index: number
  page_size: number
  sort?: string
  direction?: string
}

export type PostSaveConversionRuleRequestType = {
  rule_name: string
  type: string
  product_origins: {
    product_id: number
    quantity: number
  }[]
  product_destinations: {
    product_id: number
    quantity: number
  }[]
}

export const getConversionList = (params: GetConversionListRequestType) =>
  axiosInstanceApiGateway.Get<GetConversionListResponseType[]>({
    url: '/wims/internal/v1/manufacturing-rules',
    params,
    config: {
      paramsSerializer: {
        serialize: (p) => buildQueryParams(p).toString(),
      },
    },
  })

export const postSaveConversionRule = (data: PostSaveConversionRuleRequestType) =>
  axiosInstanceApiGateway.Post<{ message: string }>({
    url: '/wims/internal/v1/manufacturing-rules',
    data,
  })

export const putUpdateConversionRule = (
  id: number,
  data: Omit<PostSaveConversionRuleRequestType, 'type'>,
) =>
  axiosInstanceApiGateway.Put<{ message: string }>({
    url: `/wims/internal/v1/manufacturing-rules/${id}`,
    data,
  })

export const deleteConversionRule = (id: number) =>
  axiosInstanceApiGateway.Delete({
    url: `/wims/internal/v1/manufacturing-rules/${id}`,
  })
